<template>
    <Head title="Votação de Fotos" />
    <Authenticated>
        <Heading title="Votação de Fotos" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <div v-if="!isComputer" class="h-[60vh] flex justify-center items-center p-4">
            <h1 class="text-primary font-bold text-2xl">Utilize um computador para acessar votação de fotos.</h1>
        </div>

        <div
            v-else
            class="bg-gray-100 px-6 py-8 flex items-start gap-x-8 w-full"
        >
            <FilterGallery
                :currentContest="selectedContestData"
                :class="{'invisible' : preFilter}"
                :regions="regions"
                :subregions="subregions"
                :pdvChannels="pdvChannels"
                :preFilterData="preFilterData"
                :participants="participants"
                :stores="stores"
                @updateFilter="filterTransactions($event)"
            />
            <div class="min-h-[70vh] w-full">
                <section class="sm:pt-2 flex flex-col">
                    <div class="flex items-center text-primary text-xs hover:underline cursor-pointer">
                        <Icon name="SetaEsquerda" class="w-4"/>
                        <a>Voltar</a>
                    </div>
                    <div class="flex gap-x-4">
                        <a :href="route('photo-voting')" class="text-sm hover:underline cursor-pointer">Página Inicial</a>
                        <span>/</span><a href="" class="text-sm hover:underline cursor-pointer" :class="{'text-primary font-bold' : preFilter}">Começar Votação</a>
                        <span v-if="!preFilter">/</span><a v-if="!preFilter" class="text-primary font-bold text-sm">Página de Resultados</a>
                    </div>
                    <div class="flex items-center justify-between">
                        <h2 v-if="preFilter" class="text-primary font-bold mt-4">Começar Votação</h2>
                        <h2 v-else-if="!hasSomeDescription" class="text-primary font-bold mt-4">Página de Resultados</h2>
                        <Button
                            v-else
                            class="bg-primary !text-white p-4 max-w-[120px]"
                            @click="showMechanicDescription = true"
                        >
                            Mecânica
                        </Button>

                        <div v-if="!preFilter" class="flex justify-between">
                            <div class="flex gap-9 mb-4">
                                <template v-if="isMerchanCorporateStage2">
                                <div class="p-3 rounded border border-amber-300 bg-amber-50 text-amber-800 text-sm max-w-[520px]">
                                    Para concluir o nível 2 é necessário um usuário do tipo <b>Merchan Corporativo</b>.
                                    Esta etapa está aberta apenas para votação.
                                </div>
                                </template>

                                <Button
                                v-else
                                class="bg-primary !text-white p-4"
                                :onclick="() => (showCompleteModal = true)"
                                :enabled="isAllowedToEndVote"
                                >
                                Concluir Votação
                                </Button>
                            </div>
                            </div>

                    </div>
                </section>

                <section v-if="preFilter" class="flex justify-center items-center w-full h-full pt-14">
                    <div v-if="loadingPreFilter" class="pt-12 translate-x-[-150px]">
                        <Spinner />
                    </div>
                    <PreFilterGalleries
                        v-else
                        class="translate-x-[-150px]"
                        :selectedContestData="selectedContestData"
                        :regions="regions"
                        :subregions="subregions"
                        :participant="participant"
                        @updateFilter="filterTransactions($event, true)"
                    />
                </section>

                <div v-else class="min-h-[70vh] bg-white rounded-2xl border border-gray-300 pb-4 px-4">
                    <loading
                        :active="loading"
                        :is-full-page="true"
                        :z-index="10"
                    />
                    <div class="flex items-center justify-between pb-4 sticky top-[62px] bg-white z-10 pt-4">
                        <p>
                            Nível de Votação: <span class="font-bold">{{ votingLevelDisplay }}</span>
                        </p>
                        <p>
                            Total de Fotos Disponíveis para Votação: <span class="font-bold">{{ totalAvaibleCount }}</span>
                        </p>
                        <p>
                            Fotos Selecionadas: <span class="font-bold">{{ currentVoteCount }}</span> (Mínimo não obrigatório: {{ maxVotes }})
                        </p>
                        <div class="flex gap-x-2">
                            <h1>Modo de visualização:</h1>
                            <div @click="miniatureMode = false" class="border border-gray-500 rounded text-xs bg-gray-200 cursor-pointer hover:bg-gray-300" :class="{'!bg-gray-300' : !miniatureMode}">
                                <Icon class="w-6 text-gray-500" name="GalleryCard"/>
                            </div>
                            <div @click="miniatureMode = true" class="border border-gray-500 rounded text-xs bg-gray-100 cursor-pointer hover:bg-gray-300" :class="{'!bg-gray-300' : miniatureMode}">
                                <Icon class="w-6 text-gray-500" name="GalleryCardMiniature"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            id="infinite-list"
                            class="flex justify-start gap-x-11 gap-y-8 flex-wrap"
                        >
                            <VotingPhotosCard
                                :showInModal="showInModal"
                                :gallery="item"
                                :positions="computedPositions"
                                :totalPositionsList="computedTotalPositionsList"
                                :currentVoteCount="currentVoteCount"
                                :contest="campaigns"
                                :contestStage="contestStatus"
                                :currentContest="selectedContestData"
                                :miniatureMode="miniatureMode"
                                v-for="(item, key) in loadedGalleries"
                                :key="key"
                                @updateVote="handleVoteUpdate($event)"
                                @updateRanking="handleVoteRanking($event)"
                                @showParticipants="handleShowParticipantsModal($event)"
                            />
                        </div>
                        <Pagination :limit="meta.limit" :total="meta.total" :startPage="meta.page" @page:selected="setPage($event)"/>
                    </div>
                </div>

            </div>
        </div>

        <transition v-if="showCompleteModal">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-2xl max-w-[250px] w-full px-4 py-2 relative"
                >
                    <h1 class="text-primary font-bold text-xl">Votação</h1>
                    <button
                        class="absolute right-2 top-2"
                        @click="showCompleteModal = false"
                    >
                        <Icon name="Fechar" />
                    </button>

                    <p class="pt-2">Selecione uma ação para concluir a votação.</p>
                    <div class="flex flex-col gap-y-2 mt-4">
                        <a :href="route('photo-voting')">
                            <Button
                                class="p-3"
                            >
                                Salvar e Continuar Depois
                            </Button>
                        </a>
                        <Button
                            class="bg-primary !text-white p-3"
                            @click.prevent="submit"
                            :enabled="isAllowedToEndVote"
                        >
                            Concluir Votação
                        </Button>
                    </div>
                </div>
            </div>
        </transition>




        <transition v-if="$page.props.flash.error || $page.props.flash.success || $page.props.flash.warning">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[8px] max-w-[450px] w-full px-4 py-4"
                >
                    <button class="float-right" @click="handleCloseResponseModal()">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        {{ $page.props.flash.success ? "Sucesso" : ($page.props.flash.warning ? "Atenção" : "Erro") }}
                    </h1>
                    <p class="mt-2.5 font-bold">
                        {{
                            $page.props.flash.success
                                ? $page.props.flash.success
                                : ($page.props.flash.warning ? $page.props.flash.warning : $page.props.flash.error)
                        }}
                    </p>

                    <div v-if="$page.props.flash.warning && $page.props.flash.subregionErrors && $page.props.flash.subregionErrors.length > 0" class="mt-4">
                        <p class="text-sm text-gray-600">Sub-regiões com falha:</p>
                        <ul class="mt-1 text-sm list-disc list-inside text-red-600">
                            <li v-for="id in $page.props.flash.subregionErrors" :key="id">
                                {{ getSubregionName(id) }}
                            </li>
                        </ul>
                        <div class="flex gap-x-4 mt-4">
                            <Button buttonStyle="solid" @click="retryFailedSubregions()">Tentar novamente</Button>
                            <Button @click="handleCloseResponseModal()">Fechar</Button>
                        </div>
                    </div>

                    <div v-else-if="$page.props.flash.success" class="mt-4">
                        <p>Você deseja continuar votando nessa campanha?</p>

                        <div class="flex gap-x-4 mt-4">
                            <Button buttonStyle="solid" @click="handleCloseResponseModal()">Sim</Button>

                            <a class="w-full h-full" :href="route('photo-voting')">
                                <Button>
                                    Voltar
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition v-if="showParticipantModal">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-[4px] px-4 py-4 relative"
                >
                    <button class="absolute top-2 right-2" @click="showParticipantModal = false">
                        <Icon name="Fechar" />
                    </button>
                    <h1 class="text-[20px] font-bold text-primary">
                        Colaboradores da execução
                    </h1>
                    <ul class="uppercase">
                        <li v-for="(galleryParticipant, key) in participantsToShowInModal" :key="key">{{galleryParticipant.participant?.name}}</li>
                    </ul>
                </div>
            </div>
        </transition>
        <transition v-if="showMechanicDescription">
            <div
                class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
            >
                <div
                    class="bg-white border-[1px] border-gray-200 rounded-2xl max-w-[500px] w-full px-4 py-2 relative"
                >
                    <h1 class="text-primary font-bold text-xl">Mecânica</h1>
                    <button
                        class="absolute right-2 top-2"
                        @click="showMechanicDescription = false"
                    >
                        <Icon name="Fechar" />
                    </button>

                    <article class="flex flex-col gap-y-4 mt-4">
                        <div v-if="selectedContestData.descriptionMechanicMerchan">
                            <h1 class="font-bold">Mecânica Merchan</h1>
                            <p v-html="selectedContestData.descriptionMechanicMerchan">
                            </p>
                        </div>
                        <div v-if="selectedContestData.descriptionMechanicWinnerMerchan">
                            <h1 class="font-bold">Ganhadores Merchan</h1>
                            <p v-html="selectedContestData.descriptionMechanicWinnerMerchan">
                            </p>
                        </div>
                        <div v-if="selectedContestData.descriptionMechanicWinnerLeader">
                            <h1 class="font-bold">Ganhadores Líder</h1>
                            <p v-html="selectedContestData.descriptionMechanicWinnerLeader">
                            </p>
                        </div>
                        <div v-if="selectedContestData.descriptionMechanicWinnerManager">
                            <h1 class="font-bold">Ganhadores Gerente</h1>
                            <p v-html="selectedContestData.descriptionMechanicWinnerManager">
                            </p>
                        </div>
                        <div>
                            <div v-if="contestUniqueCategoriesText.length" class="bg-gray-100 border rounded-md w-full flex font-semibold">
                                <div class="bg-primary text-white rounded-md p-4 h-full text-center">Categorias <br> Elegíveis</div>
                                <div class="h-full w-full p-4 text-center">
                                    <p>
                                        {{contestUniqueCategoriesText}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedContestData?.moreInformation">
                            <div class="bg-gray-100 border rounded-md w-full flex flex-col">
                                <div class="bg-primary text-white rounded-t-md p-2 h-full text-centerfont-semibold">Informações Adicionais</div>
                                <div class="p-2" v-html="selectedContestData?.moreInformation"></div>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </transition>
        <Gallery :gallery="currentGallery" />
    </Authenticated>
</template>

<script>
import moment from "moment";
import { Head, Link } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import Authenticated from "@/Layouts/Authenticated.vue";
import Gallery from "@/Components/Gallery.vue";
import Carousel from "@/Components/CarouselSimple.vue";
import PreFilterGalleries from "@/Components/PhotosVoting/PreFilterGalleries.vue";
import VotingPhotosCard from "@/Components/VotingPhotosCard.vue";
import FilterGallery from "@/Components/PhotosVoting/FilterGallery.vue";
import Spinner from "@/Components/UI/Loaders/Spinner.vue";
import Pagination from "@/Components/UI/Pagination.vue";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Authenticated,
        Head,
        Heading,
        Head,
        Icon,
        Button,
        Gallery,
        Carousel,
        PreFilterGalleries,
        VotingPhotosCard,
        FilterGallery,
        Spinner,
        Pagination,
        loading,
        Link,
    },

    props: {
        selectedContestData: Object,
        galleries: Object,
        regions: Object,
        subregions: Object,
        weeklypassphrases: Object,
        pdvChannels: Object,
        participant: Object,
    },

    data() {
        return {
            showCompleteModal: false,
            currentVoteCount: 0,
            currentPodiumPositions: [],
            votesToAwait: [],
            selectedContest: this.selectedContestData,
            selectedSubRegions: [],
            selectedRegions: [],
            loadedGalleries: this.galleries,
            currentGallery: "",
            currentPage: 0,
            total: 0,
            totalAvaibleCount: 0,
            loadingPreFilter: false,
            loading: false,
            preFilter: true,
            completeStageInProgress: false,
            miniatureMode: false,
            preFilterData: {},
            participants: [],
            stores: [],
            showParticipantModal: false,
            participantsToShowInModal: [],
            filterData: {},
            meta: {
                total: 0,
                limit: 24,
                page: 0,
            },
            showMechanicDescription: false,
        };
    },
    computed: {
        computedTotalPositionsList() {
            let positions = [];
            const contest = this.selectedContest;
            const contestStage = this.contestStatus || 1;

            let qtd = contest.qtdWinningPictures;

            if (contest.hasPodium)
                qtd = contest.qtdWinningPictures + (contest?.qtdPodiumPictures || 0);

            if (contestStage > 3)
                qtd = (contest?.qtdPodiumPictures || 0);
            else if (contestStage == 2)
                qtd = qtd * 2;

            for (let index = 1; index <= qtd; index++) {
                positions.push(index);
            }

            return positions;

        },
        computedPositions() {
            let positions = [];
            const contest = this.selectedContest;
            const contestStage = this.contestStatus || 1;
            const galleries = this.currentPodiumPositions;

            let qtd = contest.qtdWinningPictures;

            if (contest.hasPodium)
                qtd = contest.qtdWinningPictures + (contest?.qtdPodiumPictures || 0);

            if (contestStage > 3)
                qtd = (contest?.qtdPodiumPictures || 0);
            else if (contestStage == 2)
                qtd = qtd * 2;

            for (let index = 1; index <= qtd; index++) {
                positions.push(index);
            }

            positions = positions.filter((position) => {
                return (
                    galleries.filter(
                        (gallery) =>
                        gallery.validation[
                            `positionStage${contestStage}`
                        ] &&
                        gallery.validation[
                            `positionStage${contestStage}`
                        ] == position
                        ).length == 0
                        );
            });



            return positions;
        },
        contestStatus() {
            let { rawRegions } = this.filterData || {};
            return this.fetchRegionStatus(rawRegions);
        },
        maxVotes() {
            const maxVotePerStage = this.maxVotesByStage;
            return maxVotePerStage < this.total? maxVotePerStage: this.total;
        },
        maxVotesByStage() {
            const contest = this.selectedContest;
            let value = undefined;

            switch (this.contestStatus) {
                case 3:
                    if (contest?.hasPodium)
                        value = (
                            contest?.qtdWinningPictures +
                            (contest?.qtdPodiumPictures || 0)
                        );
                    else
                        value = contest?.qtdWinningPictures;
                    break;
                case 4:
                    value = contest?.qtdPodiumPictures;
                    break;
                default:
                    value = ((contest?.qtdWinningPictures) +
                            (contest?.qtdPodiumPictures || 0)) * 2;
                    break;
            }

            return value;
        },
        minVotesByStage() {
            const contest = this.selectedContest;
            let value = undefined;
            switch (this.contestStatus) {
                case 3:
                    if (contest?.hasPodium)
                        value = (
                            contest?.qtdWinningPictures +
                            (contest?.qtdPodiumPictures || 0)
                        );
                    else
                        value = contest?.qtdWinningPictures;
                    break;
                case 4:
                    value = contest?.qtdPodiumPictures;
                    break;
                default:
                    value = (
                        contest?.qtdWinningPictures +
                        (contest?.qtdPodiumPictures || 0)
                    ) * 1;
                    break;
            }

            return value;
        },
        isAllowedToEndVote() {
            const contest = this.selectedContest;
            let responsible;
            const contests = this.$page.props.auth.user.contestJudges;

            const contestStage = this.contestStatus || 1;

            switch (contestStage) {
                case 1:
                    responsible = contests?.find((item) => {
                        return contest?.id === item.contestId && item.stage == 1;
                    });

                    if (this.isContestUploadStageFinished(contest))
                        responsible = undefined;
                    break;
                case 2:
                    responsible = contests?.find((item) => {
                        return contest?.id === item.contestId && item.stage == 2;
                    });
                    break;
                case 3:
                    responsible = contests?.find((item) => {
                        return contest?.id === item.contestId && item.stage == 3;
                    });
                    break;
                case 4:
                    responsible = contests?.find((item) => {
                        return contest?.id === item.contestId && item.stage == 4;
                    });
                    break;
            }

            return Boolean(responsible);
        },
        isComputer() {
            if (navigator.userAgentData != undefined && !navigator.userAgentData.mobile) {
                return true;
            }
        },
        hasSomeDescription() {
            const {
                descriptionMechanicMerchan,
                descriptionMechanicWinnerMerchan,
                descriptionMechanicWinnerLeader,
                descriptionMechanicWinnerManager
            } = this.selectedContest;

            return descriptionMechanicMerchan || descriptionMechanicWinnerMerchan || descriptionMechanicWinnerLeader || descriptionMechanicWinnerManager;
        },
        contestUniqueCategories() {
            return this.selectedContestData?.categories.reduce((acc, curr) => {
                const {group} = curr;

                if(!acc.includes(group)) {
                    acc.push(group);
                }

                return acc;
            }, [])
        },
        contestUniqueCategoriesText() {
            const categories = this.contestUniqueCategories;
            let text = "";

            if(!categories.length) {
                return text;
            }

            if(categories.length == 1) {
                return categories[0];
            }

            const lastCategorie = categories.pop();

            text = categories.join(', ');
            text = text + " e " + lastCategorie;

            return text;
        },
        // mostra o aviso e esconde o botão se:
        // - estamos no nível 2
        // - e o usuário NÃO é Merchan Corporativo (merchanC != 'S')
        isMerchanCorporateStage2() {
            const stage = Number(this.contestStatus || 1);
            const isMerchan = String(this.participant?.merchanC ?? 'N').toUpperCase() === 'S';
            // return stage === 2 && !isMerchan;
            return false;
        },
        votingLevelDisplay() {
            const base = this.fetchRegionStatus(this.selectedRegions);
            const isMerchan = String(this.participant?.merchanC ?? 'N').toUpperCase() === 'S';

            if (isMerchan && base === 2) {
                return 3;
            }

            if (base === 3) {
                return 4;
            }

            if (base === 4) {
                return 5;
            }

            return base;
        }
    },
    methods: {
        isContestUploadStageFinished(contest) {
            return !contest?.endDate || (moment(contest?.endDate).isAfter(moment().subtract(2, 'days')));
        },
        fetchRegionStatus(rawRegions) {
            const contest = this.selectedContest;
            let regions = rawRegions;

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            if (isNationalStage || isNationalPodium) {
                return contest?.stage || 1;
            } else {
                if (regions?.length > 0) {
                    const region = regions?.length > 0 && regions[0];

                    return (
                        contest?.stage > region?.contestRegionStage
                            ? contest?.stage
                            : region?.contestRegionStage
                    ) || 1;
                } else {
                    return contest?.stage || 1;
                }
            }
        },
        async handleVoteUpdate(params) {
            this.blockVote(params);
            if (!params.loading)
                this.currentVoteCount = (await this.fetchVoteCount()) ?? 0;
        },
        async handleVoteRanking(params) {
            if (!params.loading) await this.fetchPodiumPositions();
        },
        fetchPodiumPositions() {
            const contest = this.selectedContest;
            const stage = this.fetchRegionStatus(this.selectedRegions);

            let { regions: filterRegions, subregions: filterSubregions } = this.filterData;

            let regions = filterRegions;
            let subregions = filterSubregions;

            if (contest?.stage > 1 && this.selectedContest?.winningType !== "S") {
                subregions = undefined;
            }

            if (contest?.stage > 2 && this.selectedContest?.winningType !== "R") {
                regions = undefined;
            }

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            if (isNationalStage || isNationalPodium) {
                regions = undefined;
                subregions = undefined;
            }

            this.loading = true;
            axios
                .post(route("get-podium-positions"), {
                    id: contest?.id,
                    regions,
                    subregions,
                    stage,
                })
                .then((response) => {
                    this.currentPodiumPositions = response.data;

                    this.loading = false;
                    if (this.contestStatus >= 3){
                        this.currentVoteCount = this.currentPodiumPositions.length;
                    }
                }).catch((error) => {
                    this.loading = false;
                });
        },
        async fetchVoteCount() {
            const contestStatus = this.contestStatus;
            const contest = this.selectedContest;
            let { campaign, regions, subregions, allsubregions, allregions } =
                this.filterData;

            if (allsubregions) subregions = undefined;

            if (allregions) regions = undefined;

            if (contestStatus > 1 && this.selectedContest?.winningType !== "S") {
                subregions = undefined;
            }

            if (contestStatus > 2 && this.selectedContest?.winningType !== "R") {
                regions = undefined;
            }

            if (subregions && subregions.length > 0) {
                regions = undefined;
            }

            const isNationalStage =
                contest?.stage === 3 && contest?.winningType === "N";
            const isNationalPodium =
                contest?.stage === 4 && contest?.podiumType === "N";

            if (isNationalStage || isNationalPodium) {
                regions = undefined;
                subregions = undefined;
            }

            const { data: response } = await axios.get(
                route("get-vote-count"),
                { params: { campaign, regions, subregions } }
            );

            return response?.voteCount;
        },
        blockVote({ id, loading }) {
            if (loading) {
                this.votesToAwait?.push({ id: id });
            } else {
                this.votesToAwait = this.votesToAwait?.filter((vote) => {
                    return vote.id != id;
                });
            }

            if (this.votesToAwait?.length > 0) {
                window.onbeforeunload = function () {
                    return "";
                };
            } else {
                window.onbeforeunload = false;
            }
        },
        handleName(contest) {
            return `${contest?.name} (${moment(contest?.startDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()} à ${moment(contest?.endDate)
                .locale("pt-br")
                .format("MMM")
                .toUpperCase()})`;
        },
        filterTransactions(data, isPreFilter) {
            if(isPreFilter) {
                this.preFilterData = data;
                this.loadingPreFilter = true;
            }

            this.selectedRegions = data?.rawRegions || [];
            this.selectedSubRegions = data.subregions;

            data.stage = this.fetchRegionStatus(this.selectedRegions);

            if (data.stage == 3) {
                data.orderBy = 'validation.positionStage2';
                data.orderDirection = 'ASC'
            } else if (data.stage == 4) {
                data.orderBy = 'validation.positionStage3';
                data.orderDirection = 'ASC'
            }

            this.loadedGalleries = [];
            this.loading = true;
            this.filterData = { ...data };

            const params = { ...data };

            if (params.allsubregions) params.subregions = data.subregions;

            if (data.allregions) params.regions = data.regions;

            if (params.subregions && params.subregions.length > 0) {
                params.regions = undefined;
            }

            if(this.participants.length === 0) {
                axios
                    .get(route('photos.get-participants'))
                    .then(response => {
                        if(response.status == 200) {
                            const {data} = response;

                            this.participants = data;
                        }
                    }).catch(error => {
                        console.log(error);
                    });
            }

            if(this.stores.length === 0) {
                axios
                    .get(route('photos.get-solds'))
                    .then(response => {
                        if(response.status == 200) {
                            const {data} = response;
                            this.stores = data;
                        }
                    }).catch(error => {
                        console.log(error);
                    });
            }

            axios
                .post("/photo-voting/filter/data", { ...params })
                .then(async (response) => {
                    this.preFilter = false;
                    if (Array.isArray(response?.data?.galleries))
                        if(response?.data?.galleries) {
                            this.loadedGalleries = response?.data?.galleries.map(el => {
                                return {
                                    ...el,
                                    weeklypassphrase: this.getWeeklypassphrase(el.createdAt)
                                }
                            });
                        } else {
                            this.loadedGalleries = [];
                        }

                    this.total = response?.data?.total;
                    this.totalAvaibleCount = response?.data?.totalAvaible;

                    this.meta.total = response?.data?.meta?.total;
                    this.meta.limit = response?.data?.meta?.limit;
                    this.meta.page = parseFloat(response?.data?.meta?.page);

                    if (
                        (this.contestStatus || 1) >= 2
                    )
                        this.fetchPodiumPositions();

                    this.currentVoteCount = (await this.fetchVoteCount()) ?? 0;
                    this.currentPage = 0;

                    this.loading = false;

                    if(isPreFilter) {
                        this.loadingPreFilter = false;
                    }
                }).catch(() => this.handleGalleriesLoadError());
        },
        handleGalleriesLoadError() {
            this.loading = false;
            this.loadingPreFilter = false;
            window.alert("Não foi possível carregar as fotos. Tente novamente.");
        },
        fetchGalleries(data) {
            this.loading = true;

            const params = { ...data };
            if (data.allsubregions) params.subregions = undefined;

            if (data.allregions) params.regions = undefined;

            if (params.subregions && params.subregions.length > 0) {
                params.regions = undefined;
            }

            axios
                .post("/photo-voting/filter/data", { ...params })
                .then(async (response) => {

                    if (Array.isArray(response?.data?.galleries))
                        this.loadedGalleries = response?.data?.galleries.map(el => {
                            return {
                                ...el,
                                weeklypassphrase: this.getWeeklypassphrase(el.createdAt)
                            }
                        }) || []

                    const responseTotal = response?.data?.meta?.total;
                    if (responseTotal !== undefined && responseTotal >= 0) {
                        this.meta.total = responseTotal;
                        this.total = response?.data?.total;
                    }
                    this.meta.limit = response?.data?.meta?.limit;
                    this.meta.page = parseFloat(response?.data?.meta?.page);
                    this.currentVoteCount = (await this.fetchVoteCount()) ?? 0;

                    this.loading = false;
                }).catch(() => this.handleGalleriesLoadError());
        },
        showInModal(photos) {
            this.currentGallery = {
                exhibition: photos[0],
                photos: photos,
            };
        },
        submit() {
            this.showCompleteModal = false;
            const contest = this.selectedContest;

            if (!this.isAllowedToEndVote) return;

            this.handleCompleteStage();
        },
        forceSubmit() {
            if (!this.isAllowedToEndVote) return;

            this.handleCompleteStage();
        },
        async handleCompleteStage() {
            if (this.completeStageInProgress) {
                return;
            }

            this.completeStageInProgress = true;

            this.$inertia.post(
                route("end-voting"),
                {
                    contestId: this.selectedContest?.id,
                    subregions: this.selectedSubRegions,
                },
                {
                    onFinish: () => {
                        this.completeStageInProgress = false;
                    },
                }
            );
        },
        getWeeklypassphrase(createdAt) {
            const getOnlyDate = function(date) {
                return moment(date).format('YYYY-MM-DD');
            };

            const createdDate = getOnlyDate(createdAt);

            const weeklypassphraseFiltered = this.weeklypassphrases.filter(el => getOnlyDate(el.startDate) <= createdDate && getOnlyDate(el.endDate) >= createdDate);
            const hasWeeklypassphrase = weeklypassphraseFiltered.length > 0;

            if(hasWeeklypassphrase) {
                return weeklypassphraseFiltered[0].passphrase;
            }

            return 'N/A';
        },
        handleShowParticipantsModal(participants) {
            this.participantsToShowInModal = participants;
            this.showParticipantModal = true;
        },
        setPage(page) {
            if(this.total == this.loadedGalleries.length) {
                return;
            }

            this.fetchGalleries({
                ...this.filterData,
                page,
            });
        },
        handleCloseResponseModal() {
            const {success} = this.$page.props.flash;

            if(success) {
                this.preFilter = true;
            }

            this.$page.props.flash = {success: '', error: '', warning: '', subregionErrors: []}
        },
        getSubregionName(id) {
            const subregion = (this.subregions || []).find(s => s.id === id);
            return subregion ? subregion.name : id;
        },
        retryFailedSubregions() {
            const failedIds = this.$page.props.flash.subregionErrors || [];
            this.$page.props.flash = {success: '', error: '', warning: '', subregionErrors: []};

            this.$inertia.post(
                route("end-voting"),
                {
                    contestId: this.selectedContest?.id,
                    subregions: failedIds,
                },
                {
                    onFinish: () => {
                        this.completeStageInProgress = false;
                    },
                }
            );
        }
    },
};
</script>
<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
/* .no-scroll-bar::-webkit-scrollbar {
    display: none;
} */

/* Hide scrollbar for IE, Edge and Firefox */
/* .no-scroll-bar {
    -ms-overflow-style: none;
    scrollbar-width: none;
} */
</style>
